import React, { createContext, useContext, useState } from 'react';

const EditorContext = createContext(null);

export const EditorProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [preload, setPreload] = useState(null); // { videoUrl, videoName, settings }

  const openEditor = () => { setPreload(null); setOpen(true); };
  const openEditorWithVideo = (payload) => { setPreload(payload); setOpen(true); };
  const closeEditor = () => { setOpen(false); setPreload(null); };
  const consumePreload = () => { const p = preload; setPreload(null); return p; };

  return (
    <EditorContext.Provider value={{ open, openEditor, openEditorWithVideo, closeEditor, preload, consumePreload }}>
      {children}
    </EditorContext.Provider>
  );
};

export const useEditor = () => {
  const ctx = useContext(EditorContext);
  if (!ctx) throw new Error('useEditor must be used inside EditorProvider');
  return ctx;
};
